import React from 'react';
import Helmet from 'react-helmet';

import Link from '../components/Link';
import Tags from '../components/Tags';
import date from '../libs/date.js';

import '../scss/post.scss';

export default function Template({ data, pathContext }) {
  const { markdownRemark: post } = data;
  const { next, prev } = pathContext;

  return (
    <article className="post">
      <header className="post__header">
        <h1>{post.frontmatter.title}</h1>
        <section className="post__meta">
          <time className="post__time">{date(post.frontmatter.date)}</time>
          <span className="post__tags">
          {post.frontmatter.tags.map((tag, key) => (
            <a key={key} href={"/tags/" + tag}>{tag}</a>
          ))}
          </span>
        </section>
      </header>
      <section className="post__content" dangerouslySetInnerHTML={{ __html: post.html }}></section>
    </article>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "D MMMM YYYY")
        path
        tags
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.js